<template>
    <div>
        <button aria-label="Open Video" @click="showModal">
            <i class="fas fa-video px-1 text-blue-600"></i>
        </button>
        <video-modal v-if="show" @close="hideModal" :header="video.title" :description="video.description" :url="getUrl()" :moreinfo="`Date Posted: ${video.date}`" autoplay="true" :modalvideo="true"></video-modal>
    </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
  video: Object,
});

const show = ref(false);

const showModal = () => {
  show.value = true;
};

const hideModal = () => {
  show.value = false;
};

const getUrl = () => {
  return window.route('main.download', { url: props.video.s3Path });
};
</script>
